import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import cn from 'classnames';
import { getObjectValue } from '@utility/utills';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Modal from '@components/common/Modal';
import CounterBtn from '@components/common/Counter';

const renderModifier = (modifiersObj, note) => (
  <ul className={cn('pl-2 fs-10 text-left')}>
    {modifiersObj?.map((modifier) => {
      if (modifier.modifiers.length === 1 && getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)) {
        return (
          <li key={modifier.modifierId}>
            {modifier.modifiers[0].quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">{modifier.modifiers[0].quantity} &times;</span>)}
            {modifier.modifierName}
            {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">&times; {modifier.quantity}</span>)}
            {modifier.price ? (<small className=" ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
          </li>
        );
      }
      return (
        <li key={modifier.modifierId}>
          {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">{modifier.quantity} &times;</span>)}
          {modifier.modifierName}
          {modifier.price ? (<small className="ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
          {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
          {modifier.modifiers.length > 0 && (
            renderModifier(modifier.modifiers, note)
          )}
        </li>
      );
    })}
    {note && (
      <li className="mb-30">
        {note}
      </li>
    )}
  </ul>
);

const SingleItem = (props) => {
  const cart = props.item;
  const [isOpen, setOpen] = useState(false);
  const [itemNo, setItemNo] = useState(cart.quantity);
  const themeProperties = JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
  const btnImgUrl = getObjectValue(() => themeProperties.appDefaultButtonImageUrl, false);
  const counterState = (data) => {
    const currentCount = itemNo + data;
    if (currentCount < 0) {
      // do nothing
    } else if (!(data === -1 && (itemNo === 1))) {
      setItemNo(currentCount);
      props.changeItemQuantity(currentCount, cart.internalId);
    } else {
      setOpen(true);
    }
  };

  useEffect(() => {
    setItemNo(props.item.quantity);
  }, [props.item]);

  const renderModifiyButton = () => {
    if (!cart.isUpsell) {
      const menuItemsHashTable = JSON.parse(window.sessionStorage.getItem('menuItemsHashTable')) || {};
      const isPackItem = menuItemsHashTable[cart?.menuItemId]?.pack || menuItemsHashTable[cart?.menuItemId]?.cardType === 1;
      return (
        <>
          {!cart.refill ? (
            <button
              type="button"
              className={cn(styles.removeBtnStyle, 'btn p-0')}
              onClick={() => { if (!isPackItem) props.onModifyItem(cart); }}
              aria-label="editBtn"
              disabled={isPackItem}
              style={isPackItem ? { cursor: 'not-allowed' } : {}}
            >
              <i className="fas fa-edit fs-24" aria-hidden="true" style={isPackItem ? { color: 'rgb(177,177,177)' } : {}} />
            </button>
          ) : (
            <span className="text-primary od-text-primary ">
              {LABEL().REFILL}
            </span>
          )}
        </>
      );
    }
    return '';
  };

  const item = props.item;
  const imageUrl = item.defaultMenuItemImageUrl;
  const quantity = props.geItemQuantity;
  return (
    <>
      <div className={cn('d-flex mb-2 od-text-primary justify-content-between flex-row od-container-card-background od-container-card-border', styles.cardBox)}>
        <div className={cn((cart.suppressImages || !imageUrl) ? 'd-none' : 'col-3 col-lg-3 p-0 d-flex justify-content-center align-items-center')}>
            {!cart.suppressImages && (
              <img src={imageUrl} alt="" className={cn('img-fluid mx-auto', styles.cartImgsize)} />
            )}
        </div>
        <div className={cn((cart.suppressImages || !cart.defaultMenuItemImageUrl) ? 'col-12 px-0' : 'col-9 col-lg-9 p-2')}>
          <div className={cn('p-2', props.isRefill ? 'float-left' : '')}>
            <div className={cn('fw-600 d-flex flex-row justify-content-between text-primary')}>
              <div className="fs-24">{quantity > 1 && <>{quantity} <span className="mr-1 py-2">x </span></>}{item.menuItemName}</div>
              <div className="d-flex od-text-secondary">{renderModifiyButton()}</div>
            </div>
            {item.modifierObject && item.modifierObject.length > 0 ? renderModifier(item.modifierObject, item.note) : renderModifier(item.modifiers, item.note) }
          </div>
          <div className={cn('d-flex justify-content-between p-2 fs-24 text-primary',
          )}>
            <CounterBtn counter={quantity} counterState={counterState} />
            <div className={cn(imageUrl ? 'text-right' : 'text-right px-2', 'row align-items-center fs-24 text-primary')}>
              {LABEL().CURRENCY_SYMBOL}{Number(item.price * quantity).toFixed(2)}
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={isOpen}>
        <div className="card mb-0 p-4 fs-24 od-app-background-color od-text-primary">          
          <div className="mx-0 justify-content-center align-items-center text-center">
            <div className="fw-600 pb-4 text-center">
              <div>
                {CUSTOM_MESSAGES().DELETE_ITEM_CONFIRMATION}
              </div>
            </div>
            <div className="row justify-content-center align-items-center text-center">
              {btnImgUrl ? (
                <div className="d-flex flex-row">
                  <div className="position-relative" onClick={() => { setOpen(false); }} role="presentation">
                    <img src={btnImgUrl} className={cn(styles.btnImgUrlSize, 'od-app-btn-primary')} alt="" />
                    <span className={cn(styles.btnImgUrlText, 'position-absolute od-app-btn-text-color')}>{LABEL().KIOSK_NO}</span>
                  </div>
                  <div className="position-relative" onClick={() => { setOpen(false); setItemNo(0); props.onRemoveItemFromCart(cart.internalId); }} role="presentation">
                    <img src={btnImgUrl} className={cn(styles.btnImgUrlSize, 'od-app-btn-primary')} alt="" />
                    <span className={cn(styles.btnImgUrlText, 'position-absolute od-app-btn-text-color')}>{LABEL().KIOSK_YES}</span>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-6">
                    <button className="btn btn100 btn-secondary od-btn-secondary w-100" type="button" onClick={() => { setOpen(false); }}>
                      <div className="fs-30">{LABEL().KIOSK_NO}</div>
                    </button>
                  </div>
                  <div className="col-6">
                    <button className="btn btn100 btn-primary btn-ripple od-btn-primary w-100" type="button" onClick={() => { setOpen(false); setItemNo(0); props.onRemoveItemFromCart(cart.internalId); }}>
                      <div className="fs-30">{LABEL().KIOSK_YES}</div>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

const Cart = (props) => {
  const { cart } = props;
  const cartItems = cart || [];
  const [payAtCounter, setPayAtCounter] = useState(false);

  const getSubTotal = () => {
    let subTotal = 0;
    (props.cart || []).forEach((item) => {
      if (!item.refill && !item.isLinked) subTotal += (item.price * item.quantity);
    });
    return `$${subTotal.toFixed(2)}`;
  };

  const totalComponent = (
      <div className={cn('row mx-0 fw-600 text-primary text-primary od-text-primary fs-18')}>
        <span>{LABEL().SUB_TOTAL}:&nbsp;</span>
        <span>{getSubTotal()}</span>
      </div>
  );

  const handlePriceCheck = (key) => {
    props.handleKioskPriceCheck(key);
  };

  useEffect(()=>{
    const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'))
    const payatcoun = deviceInfo?.deviceGroup?.paymentTypes?.payAtCounter ? true : false
    setPayAtCounter(payatcoun);
  }, [])

  return (
    <div className="row mx-0 align-items-center w-100 h-100 justify-content-center">
      <div className={cn('row justify-content-center w-100 p-0 h-60 overflowY justify-content-center', window.location.pathname !== '/kiosk/cart' && styles.cartHeight, cart.length === 0 && 'align-items-center')}>
        {cart.length > 0 ? (
          <div className={cn('w-100')}>
            {(cartItems || []).map((item) => !item.isLinked && (<SingleItem key={item.id} authResponse={props.authResponse} goToLandingPage={props.goToLandingPage} item={item} renderModifier={renderModifier} onRemoveItemFromCart={props.onRemoveItemFromCart} geItemQuantity={item.quantity} setCheckoutModal={props.setCheckoutModal} checkoutModal={props.checkoutModal} onModifyItem={props.onModifyItem} changeItemQuantity={props.changeItemQuantity} />))}
          </div>
        ) : (
          <div className="px-2 fs-30">
            {CUSTOM_MESSAGES().YOUR_CART_EMPTY}
          </div>
        )}
      </div>
      {window.location.pathname === '/kiosk/cart' && (
        <>
          <div className={cn('h-5 row justify-content-center align-items-center w-100 px-4')}>
            {totalComponent}
          </div>
          <div className={cn('h-10 px-4 w-100 row align-items-end',props.paymentBtn.length > 0 && 'justify-content-center')}>
            <div className="col-6 pl-0">
              <button className={cn('w-100 btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100')} type="button" onClick={() => props.goToOrder()}>
                <div className="fs-18">{LABEL().ORDER_MORE_ITEMS}</div>
              </button>
            </div>
            {props.paymentBtn?.label && <div className="col-6 pr-0 ">
              <button className={cn('w-100 btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-20')} disabled={!(props.paymentBtn.key === 'card' || props.paymentBtn.key === 'scan' || props.paymentBtn.key === 'all')} type="button" onClick={() => (props.cart.length === 0 ? props.goToOrder() : handlePriceCheck(props.paymentBtn.key))}>
                <div className="fs-18">{props.paymentBtn.label}</div>
              </button>
            </div>}
            {payAtCounter && props.paymentBtn?.label && <div className="col-6  pl-0">
            </div> }
            {payAtCounter &&  <div className={`col-6 pr-0 mt-2 ${props.paymentBtn?.label? 'mb-2':''}`}>
              <button className={cn('w-100 btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-20')} type="button" onClick={() => (props.cart.length === 0 ? props.goToOrder() : handlePriceCheck('payatcounter'))}>
                <div className="fs-18">{LABEL().PAY_AT_COUNTER}</div>
              </button>
            </div>}
           
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
